import '../pages.css';
import { Link } from 'react-router-dom';

const ZirconiaHybridImplantBridge = () => {
    return (
        <div className="page product-detail">
            <section className="product-detail-hero">
                <div className="product-detail-hero-content">
                    <Link to="/products/implants" className="back-link">← Back to Implants/Hybrid</Link>
                    <h1>Zirconia Hybrid Implant Bridge</h1>
                    <p className="product-tagline">Advanced restorative solution for edentulous patients</p>
                </div>
            </section>

            <section className="product-detail-content">
                <div className="content-container">
                    <div className="product-section">
                        <h2>Description</h2>
                        <p>
                            Zirconia hybrid implant bridges from <strong>AbELab</strong> offer an advanced restorative solution for edentulous
                            patients seeking superior function and esthetics. These restorations can be supported by as few as four implants and
                            are milled from a single block of monolithic zirconia, ensuring exceptional strength and durability. The highly
                            translucent material provides natural esthetics, while the rigid framework delivers outstanding stability. This
                            solution significantly enhances mastication, phonetics, and overall patient satisfaction.
                        </p>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default ZirconiaHybridImplantBridge;
